<template>
  <el-dialog
    title="设置贷款利率"
    :visible.sync="addVisible"
    width="500px"
    top="30vh"
    :close-on-click-modal="false"
  >
    <p class="tip"><i class="el-icon-warning"></i>更新后房贷计算器将使用最新值计算，请谨慎修改！</p>

    <el-form class="form-container" :model="caputerInfo" :rules="calputerRule" ref="calputerForm">
        <div class="form-item">
            <div class="form-label">
                <span class="label">商贷基础利率：</span>
                <label class="warn">*</label>
            </div>
            <div class="form-input-item">
                <el-form-item prop="base_rate">
                    <el-input  class="input-control" v-model.trim="caputerInfo.base_rate">
                        <template slot="append">%</template>
                    </el-input>
                </el-form-item>
            </div>
        </div>
       <div class="form-item">
            <div class="form-label">
                <span class="label">商贷LPR基础利率：</span>
                 <label class="warn">*</label>
            </div>
            <div class="form-input-item">
                <el-form-item prop="lpr_rate">
                    <el-input  class="input-control" v-model.trim="caputerInfo.lpr_rate">
                        <template slot="append">%</template>
                    </el-input>
                </el-form-item>
            </div>
        </div>
        <div class="form-item">
            <div class="form-label">
                <span class="label">公积金贷款利率：</span>
                <label class="warn">*</label>
            </div>
            <div class="form-input-item">
                <el-form-item prop="fund_rate">
                    <el-input  class="input-control" v-model.trim="caputerInfo.fund_rate">
                        <template slot="append">%</template>
                    </el-input>
                </el-form-item>
            </div>
        </div>
        <div class="form-button" style="margin-left: 165px;">
            <el-button type="primary" @click="submitForm('calputerForm')">保 存</el-button>
            <el-button type="info" plain @click.stop.prevent="hideMenu">取 消</el-button>
        </div>
    </el-form>
  </el-dialog>
</template>

<script>
import { setCalputer } from "@/service/customer";
export default {
  name: "calputer",
  props: {
    callback: Function,
  },

  data() {
    const validateRate = (rule, value, callback) => {
            const type = rule.type
            if (value === '') callback()
            else if (!/^[0-9]+(\.?[0-9]{0,2})$/.test(value)) {
                callback(new Error(`${type}为最多两个小数的数字`))
            } else if (parseFloat(value) === 0) {
                callback(new Error(`${type}必须大于0`))
            } else {
                callback()
            }
    }
    return {
      addVisible: false,
      caputerInfo:{
          base_rate:'',
          lpr_rate:'',
          fund_rate:''
      },
      calputerRule:{
        base_rate: [
            { required: true, message: '商贷基础利率不能为空', trigger: 'blur'},
            {validator: validateRate, type: "商贷基础利率", trigger: "blur"},
        ],
        lpr_rate: [
            { required: true, message: '商贷LPR基础利率不能为空', trigger: 'blur'},
            {validator: validateRate, type: "商贷LPR基础利率", trigger: "blur"},
        ],
        fund_rate: [
            { required: true, message: '公积金贷款利率', trigger: 'blur'},
            {validator: validateRate, type: "公积金贷款利率", trigger: "blur"},
        ],
      },
    };
  },
  mounted() {},
  methods: {
    open() {
        this.caputerInfo={
             base_rate:'',
            lpr_rate:'',
            fund_rate:''
        }
        this.resetForm()
        this.addVisible=true;
    },
    hideMenu(){
        this.addVisible=false;
    },
 
    submitForm(formName){
        this.$refs[formName].validate(async (valid) => {
            if (valid) {
                setCalputer(this.caputerInfo).then((data) => {
                    this.$message({
                        message: '设置成功',
                        type: 'success',
                        duration: 3 * 1000
                    })
                    this.resetForm()
                    this.hideMenu()
                    this.callback && this.callback()
                }).catch(err => {
                    const message = err.message
                    this.$message({
                        message: message || '添加失败',
                        type: 'error',
                        duration: 3 * 1000
                    })
                })  

            } else {
                return false
            }
        })
    },
    resetForm(){
    }
  },
};
</script>

<style scoped>
.form-container .form-item .form-label {
    width: 30%;
    float: left;
    text-align: right;
    line-height: 36px;
    margin-right: 10px;
}
.form-container .form-item .warn{
    color: red;
}
.form-container .form-item .form-input-item {
    width: 60%;
    float: left;
}
.tip{
    margin-bottom: 30px;
    text-align: center;
}
</style>
